// import Vue from 'vue'
import Router from 'vue-router'

// Vue.use(Router)
export default new Router({
	// mode: 'history',
	// base: '/dist',
	routes: [{
		path: '/',
		component: resolve => require(['../pages/homepage/index.vue'], resolve),
		name: '首页',
        meta: {title: '万事达卡会籍礼遇平台', keepAlive: true}
	}, {
		path: '/login',
		component: resolve => require(['../pages/login.vue'], resolve),
		name: '登录',
        meta: {title: '万事达卡会籍礼遇平台'}
	},{
		path: '/bin',
		component: resolve => require(['../pages/bin.vue'], resolve),
		name: '验证',
        meta: {title: '万事达卡会籍礼遇平台'}
	},
	{
		path: '/list/:type?/:city?',
		component: resolve => require(['../pages/homepage/detail.vue'], resolve),
		name: '权益',
        meta: {title: '万事达卡会籍礼遇平台', keepAlive: true, isBack: false}
	},
	{
		path: '/detail/:id?/:type?/:title?',
		component: resolve => require(['../pages/homepage/list.vue'], resolve),
		name: '卡券',
        meta: {title: '万事达卡会籍礼遇平台'}
	}, 
	{
		path: '/info/:type?/:brandName?/',
		component: resolve => require(['../pages/homepage/info.vue'], resolve),
		name: '介绍',
        meta: {title: '万事达卡会籍礼遇平台'}
	}, {
		path: '/reserve/:id?/:type?/:title?/:ticketId?/:hasCode?',
		component: resolve => require(['../pages/homepage/reserve.vue'], resolve),
		name: '预约',
        meta: {title: '万事达卡会籍礼遇平台'}
	}, {
		path: '/result/:codeUrl?/:secondCode?',
		component: resolve => require(['../pages/homepage/result.vue'], resolve),
		name: '核销码',
        meta: {title: '万事达卡会籍礼遇平台'}
	}, {
		path: '/User/:orderId?',
		component: resolve => require(['../pages/homepage/order.vue'], resolve),
		name: '订单',
        meta: {title: '万事达卡会籍礼遇平台'}
	}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js